let mutations = {
  INIT_APP (state, data) {
    state.unpaidTxnCount = data.unpaidTxnCount
    state.outstandingAmount = data.outstandingAmount
    state.availableCreditLimit = data.availableCreditLimit
    state.dueTxnCount = data.dueTxnCount
    state.overdueTxnCount = data.overdueTxnCount
    state.daysToFreeze = data.daysToFreeze
    state.creditPaused = data.creditPaused
    state.creditPauseMsg = data.creditPauseMsg
    state.foodForThought = data.foodForThought
    state.unsettledTransactionList = data.unsettledTransactionList
    state.alertMessage = data.alertMessage
  }
}
export default mutations



// WEBPACK FOOTER //
// ./src/store/home/mutations.js